import { atom } from 'jotai';
import { ConversationsState, StrapiConversation } from '../../../core/models/strapi-conversation.model';
import { StrapiChatMessage } from '../../../core/models/strapi-chat-message.model';

const conversationsAtom = atom<ConversationsState>({ asUser: [], asVendor: [] });

const activeConversationAtom = atom<StrapiConversation | null>(null);

const messagesAtom = atom<StrapiChatMessage[]>([]);

const totalUnreadAtom = atom<number>(0);

const messagesPaginationAtom = atom<{ page: number; hasMore: boolean }>({ page: 1, hasMore: false });

const messagesLoadingAtom = atom<boolean>(false);

export { conversationsAtom, activeConversationAtom, messagesAtom, totalUnreadAtom, messagesPaginationAtom, messagesLoadingAtom };
